import { useTranslation } from '../../../../utils/useTranslation';
import { Typography } from '../../components/Typography/Typography';
import { useProvider } from '../../hooks/useProvider';
import ns from '../../translations';

const TTS_INFO_LINKS: Record<string, string> = {
  vgtts: 'https://www.vg.no/informasjon/redaksjonelle-avgjorelser/5gyprx',
  aptts:
    'https://www.aftenposten.no/norge/i/RGK3aJ/aftenposten-lanserer-ki-basert-stemme-som-kan-lese-opp-alle-artikler',
};

export const TtsInfoFooter = () => {
  const { t } = useTranslation(ns);
  const { configProvider } = useProvider();

  const infoLink = TTS_INFO_LINKS[configProvider];

  return (
    <div className="vgp-tts-layout-info-text">
      <Typography variant="caption" color="primary">
        {t(
          'The voice reading this article is generated using artificial intelligence.'
        )}{' '}
        {infoLink && (
          <a
            href={infoLink}
            target="_blank"
            rel="noopener noreferrer"
            className="vgp-tts-layout-info-link"
          >
            {t('Read more here.', {}, { noJSX: true })}
          </a>
        )}
      </Typography>
    </div>
  );
};
